import { Table, TableContainer, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import AnswerSubmit from './AnswerSubmit';

const AnsCommentTable = ({ comments, handleSubmit, handleSkip }) => {
    
    return(

        <div>
            <div>
            <TableContainer>
                <Table variant='simple'>
                    <Thead>
                        <Tr>
                            <Th>Comment</Th>
                            <Th>Remark</Th>
                            <Th>Added By</Th>
                            <Th>Created At</Th>
                            <Th>Answer</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        
                            {
                                comments.map((comment, index) => (
                                    <Tr key={comment.id}>
                                        <Td>{comment.comment}</Td>
                                        <Td>{comment.remark}</Td>
                                        <Td>{comment.added_by}</Td>
                                        <Td>{new Date(comment.created_at).toDateString()}</Td>
                                        <Td>
                                            <AnswerSubmit index={index} comment={comment} handleSubmit={handleSubmit} handleSkip={handleSkip} />
                                        </Td>                                      
                                    </Tr>
                                ))
                            }
                            
                    </Tbody>
                </Table>
            </TableContainer>
            </div>
        </div>

    )
}

export default AnsCommentTable;